import { render } from "./clsBtn.vue?vue&type=template&id=ff1830dc&scoped=true"
import script from "./clsBtn.vue?vue&type=script&lang=js"
export * from "./clsBtn.vue?vue&type=script&lang=js"

import "./clsBtn.vue?vue&type=style&index=0&id=ff1830dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1830dc"]])

export default __exports__